import { useMemo } from 'react';
import { useDefaultEnv } from '../../pages/environments/DefaultEnvContext';

const useIsManagedPackageInstalled = () => {
  const defaultCreationEnvironment = useDefaultEnv();
  const isManagedPackagedInstalled = useMemo(
    () => defaultCreationEnvironment?.isManagedPackageInstalled,
    [defaultCreationEnvironment],
  );

  return !!isManagedPackagedInstalled;
};

export default useIsManagedPackageInstalled;
